const mutations = {
  setLoading: (state: { isLoading: boolean }, action: boolean) => {
    state.isLoading = action;
  },
};
export default mutations;
